import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const HealthDataConflictModal = ({
  isOpen,
  onCancel,
  onResolve,
  isResolving,
}) => (
  <Modal
    isOpen={isOpen}
    toggle={isResolving ? undefined : onCancel}
    backdrop="static"
    centered
    fade={false}
  >
    <ModalHeader>Registro duplicado</ModalHeader>
    <ModalBody>
      <p className="text-sm font-medium text-slate-700">
        Ya existe un registro de este día, quieres promediar o reemplazar
      </p>
    </ModalBody>
    <ModalFooter>
      <Button
        type="button"
        color="primary"
        onClick={() => onResolve("average")}
        disabled={isResolving}
      >
        Promediar
      </Button>
      <Button
        type="button"
        color="warning"
        onClick={() => onResolve("replace")}
        disabled={isResolving}
      >
        Reemplazar
      </Button>
      <Button
        type="button"
        color="secondary"
        onClick={onCancel}
        disabled={isResolving}
      >
        Cancelar
      </Button>
    </ModalFooter>
  </Modal>
);

export default HealthDataConflictModal;
